import React from 'react';
import { Link } from 'theme-ui';

export const linkifyText = (text: string, color: string = '#6366f1'): JSX.Element[] => {
  if (!text) return [];
  const urlRegex = /((?:https?:\/\/|www\.|frontapp:)[^\s]+)/gi;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    const isUrl = /^(?:https?:\/\/|www\.|frontapp:)/i.test(part);
    if (isUrl) {
      const href = part.toLowerCase().startsWith('www.') ? `https://${part}` : part;
      return (
        <Link
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          sx={{
            color: `${color} !important`,
            textDecoration: 'underline !important',
            wordBreak: 'break-all',
            "&, html[data-theme='light'] td.fixed-column-2.table-cell &, html[data-theme='light'] td.fixed-column-2 &, html[data-theme='dark'] td.fixed-column-2.table-cell &, html[data-theme='dark'] td.fixed-column-2 &": {
              color: `${color} !important`
            }
          }}
        >
          {part}
        </Link>
      );
    }
    return <span key={index}>{part}</span>;
  });
};